import { format } from "date-fns";

const Filter = ({
  setFilter,
  filter,
  fetch,
  onClick,
  onChange,
  provincias,
  setData,
}) => {
  return (
    <div className="row py-3">
      <div className="col-md-3 mb-3">
        <div className="d-flex">
          <input
            className="form-control border border-dark py-1"
            style={{ borderRadius: "10px 0px 0px 10px" }}
            type="search"
            name="search"
            placeholder="Buscar"
            onChange={(e) => onChange(e)}
          />
          <label
            className="btn btn-dark border-0 me-2 py-1"
            style={{ borderRadius: "0px 10px 10px 0px" }}
          >
            <i className="bi bi-search"></i>
            <button
              className="d-none"
              name="search"
              onClick={(e) => onClick(e)}
            ></button>
          </label>
        </div>
      </div>
      <div className="col-md-3 mb-3">
        <select
          class="form-select"
          aria-label="Default select example"
          onChange={(e) => {
            if (e.target.value == "todos") {
              let params = filter;
              delete params["filter[eventos.provincia]"];
              setFilter({ ...params });
              return fetch(setData, params, "/reportes");
            }

            setFilter({ ...filter, ["filter[eventos.provincia]"]: e.target.value });
            let params = { ...filter, ["filter[eventos.provincia]"]: e.target.value };

            fetch(setData, params, "/reportes");
          }}
        >
          <option selected>Seleccionar provincia</option>
          <option value={"todos"}>Todos</option>
          {provincias.map((provincia) => {
            return (
              <option
                value={provincia.provincia}
              >{`${provincia.provincia}`}</option>
            );
          })}
        </select>
      </div>
      <div className="col-md-3 mb-3">
        <select
          class="form-select"
          aria-label="Default select example"
          onChange={(e) => {
            if (e.target.value == "todos") {
              let params = filter;
              delete params["filter[status]"];
              setFilter({ ...params });
              return fetch(setData, params, "/reportes");
            }
            setFilter({ ...filter, ['filter[status]']: e.target.value });
            let params = { ...filter, ['filter[status]']: e.target.value };
            fetch(setData, params, "/reportes");
          }}
        >
          <option selected>Seleccionar estado</option>
          <option value="todos">Todos</option>
          <option value="activo">Activo</option>
          <option value="inactivo">Inactivo</option>
          <option value="reembolso">Reembolsado</option>
          <option value="rechazado">Rechazado</option>
          <option value="liquidado">liquidado</option>
        </select>
      </div>
    </div>
  );
};

export default Filter;
